/** @returns {unknown[]} */
export const normalizeSummarizationJobs = (summarization) => {
  if (!summarization || summarization.error) return [];
  if (Array.isArray(summarization)) return summarization;
  return [summarization];
};

const parseJobTime = (value) => {
  if (!value) return null;
  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? null : parsed;
};

/** Most recent job first. */
export const sortSummarizationJobsNewestFirst = (jobs) => {
  return [...jobs].sort((a, b) => {
    const timeA = parseJobTime(
      a.job_start_time || a.upload_date || a.job_end_time
    );
    const timeB = parseJobTime(
      b.job_start_time || b.upload_date || b.job_end_time
    );
    if (timeA != null && timeB != null) return timeB - timeA;
    if (timeA != null) return -1;
    if (timeB != null) return 1;
    const nameA = a.summarize_job_name || "";
    const nameB = b.summarize_job_name || "";
    return nameB.localeCompare(nameA);
  });
};

export const getSummarizationJobTimeLabel = (job) => {
  const raw = job?.job_start_time || job?.upload_date || job?.job_end_time;
  if (!raw) return "Unknown time";
  const parsed = Date.parse(raw);
  if (Number.isNaN(parsed)) return String(raw);
  return new Date(parsed).toLocaleString();
};

export const getSummarizationJobSoapNote = (job) => {
  const text = job?.soap_note;
  if (text == null) return null;
  const trimmed = String(text).trim();
  return trimmed || null;
};

export const getMostRecentSummarizeJob = (summarization) => {
  const jobs = sortSummarizationJobsNewestFirst(
    normalizeSummarizationJobs(summarization)
  );
  return jobs[0] || null;
};

export const getSummarizeJobTemplateNames = (job) => ({
  convPromptName: job?.templates_conv_prompt_name?.trim() || null,
  startingNoteName: job?.templates_starting_note_name?.trim() || null,
});
